import React from "react";


export const LoanInfo = () => {
  return (
    <div id="loan-service" className="text-center pb-5" style={{paddingTop:'6rem'}}>
      <div className="container">
        <div className="section-titles">
          <h2>Loan Services & Compliance</h2>
          <p>This Website/App facilitates loan applications in partnership with Utkarsh Small Finance Bank Limited, a financial institution licensed and regulated by the Reserve Bank of India (RBI)</p>
        </div>

        <div className="app-download-section">
           <li>Lender: Utkarsh Small Finance Bank Limited</li>
           <li>CIN: L65992UP2016PLC082804</li>
           <li>RBI License Reference: Licence No. MUM: 125 (issued November 25, 2016 under Section 22(1) of the Banking Regulation Act, 1949)</li>
           <li>Role of this Website & App: We serve only as a Direct Selling Agent (DSA) and technology platform. We do not provide loans directly. Loan approval and disbursal are solely at the discretion of Utkarsh Small Finance Bank Limited.</li>
           
        </div>
      </div>
    </div>
  );
};
